import React, { FunctionComponent } from 'react';

const PREFERENCE_LINKS = [
  { name: '完全週休2日制', path: '/two_days_off_a_week' },
  { name: '土日祝日休み', path: '/closed_on_weekends_and_holidays' },
  { name: '交通費支給', path: '/transportation_expenses' },
  { name: '昇給あり', path: '/pay_raise' },
  { name: '未経験OK', path: '/inexperienced_welcome' },
  { name: '私服勤務OK', path: '/freedom_of_clothing' },
  { name: '学歴不問', path: '/any_academic_background' },
  { name: '家賃補助あり', path: '/housing_allowance' },
  { name: 'インセンティブあり', path: '/incentives_available' },
  { name: '屋内の受動喫煙対策', path: '/smoking_countermeasures' },
  { name: 'アシスタント', path: '/assistant' },
  { name: 'オープニングスタッフ', path: '/opening_staff' },
  { name: '海外出張あり', path: '/involves_overseas_business_trips' },
  { name: 'ノルマなし', path: '/no_sales_quotas' },
  { name: '英語を活かせる', path: '/opportunity_to_use_english' },
  { name: '中国語を活かせる', path: '/opportunity_to_use_chinese' },
  { name: '韓国語を活かせる', path: '/opportunity_to_use_korean' },
  { name: '第二新卒歓迎', path: '/recent_graduates_welcome' },
  { name: '主婦・主夫歓迎', path: '/stay_moms_and_dads_welcome' },
  { name: '本社', path: '/headquarters' },
  { name: '路面店', path: '/street_level_store' },
  { name: 'フレックス勤務可', path: '/flexible_hours_available' },
  { name: 'リモートワーク可', path: '/remote_work_available' },
  { name: '時短勤務可', path: '/part_time_hours_available' },
  { name: '転勤なし', path: '/no_relocation_required' },
  { name: '残業20時間/月以内', path: '/overtime_20_hours_or_less_per_month' },
  { name: '年間休日120日以上', path: '/over_120_days_off_per_year' },
  { name: '産休・育休取得実績あり', path: '/track_record_of_employees_taking_maternity_and_parental_leave' },
  { name: 'ネイル・ピアスOK', path: '/nails_and_piercings_allowed' },
  { name: 'タトゥーOK', path: '/tattoos_allowed' },
  { name: '賞与・ボーナスあり', path: '/bonuses_available' },
  { name: '社宅・寮完備', path: '/company_housing_and_dormitories_provided' },
  { name: '託児所あり', path: '/daycare_center_available' },
];

export const Presentation: FunctionComponent = () => {
  return (
    <section className="sitetop-recruitment">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          PREFERENCES<span className="sitetop-pickup-sub">こだわり条件から探す</span>
        </h2>
      </div>
      <div className="sitetop-location-container">
        <nav className="sitetop-occupation-children">
          {PREFERENCE_LINKS.map((link) => (
            <a key={link.path} href={link.path} className="sitetop-occupation-children-word">
              {link.name}
            </a>
          ))}
        </nav>
      </div>
    </section>
  );
};
